import React, { useEffect, useState } from 'react';
import Persyaratan from '../../../modules/Persyaratan';
import View from '../../../modules/View';
import apiService from 'apiService';

const mapValuesToPostParams = async (values, idPendaftaran) => {
  const toBase64 = async (file) => {
    if (await file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    }
  };
  const properties = [];
  const newValues = Object.keys(values).map((key, i) => {
    properties[ i ] = {
      ref_persyaratan_id: values[ key ].id,
      trx_pend_perusahaan_id: idPendaftaran,
    };
    return toBase64(values[ key ].file);
  });

  const postParams = await Promise.all(newValues).then((results) =>
    properties.map((propertie, i) => ({ ...propertie, upload: results[ i ] }))
  );

  return postParams;
};

const JasaBogaPersyaratan = ({
  existingPersyaratan,
  nextStep,
  setData,
  onAfterPost,
  typeId,
  isShow,
  idPendaftaran,
  ...rest
}) => {
  const [ persyaratan, setPersyaratan ] = useState('');
  const getPersyaratan = async (refId) => {
    try {
      const responses = await apiService.get(
        `/department/persyaratan/find/${ refId }`
      );
      if (responses) {
        setPersyaratan(responses.data);
        setData((prevState) => ({
          ...prevState,
          dataPersyaratan: responses.data,
        }));
      }
    } catch (error) {
      return [];
    }
  };

  useEffect(() => {
    if (!existingPersyaratan) getPersyaratan(typeId);
    else setPersyaratan(existingPersyaratan);
  }, []);

  if (!isShow) return '';

  return (
    <>
      {/* <Persyaratan
      { ...rest }
      existingPersyaratan={ existingPersyaratan }
      refId={ typeId }
      postUrl='/department/persyaratan/upload'
      mapValuesToPostParams={ mapValuesToPostParams }
      onAfterPost={ onAfterPost || nextStep }
    /> */}
      <View
        data={ existingPersyaratan || persyaratan || [] }
        idPendaftaran={ idPendaftaran }
        handleSubmit={ nextStep }
      />
    </>
  );
};

// const Form24 = ({
//   data,
//   values,
//   handleChange,
//   handleBlur,
//   setFieldValue,
//   handleSubmit,
//   errors,
//   touched,
// }) => {
//   useEffect(() => {
//     data.persyaratan &&
//       data.persyaratan.forEach((syarat) =>
//         setFieldValue(`file_${syarat.id}`, {
//           file: null,
//           validation: null,
//           id: syarat.id,
//         })
//       );
//   }, [data]);

//   return (
//     <>
//       <div className='container-fluid pt-5 shadow-lg'>
//         <div className='container '>
//           <div className='row justify-content-center'>
//             <div className='col-lg-12'>
//               <Card marginTop={5}>
//                 <Card.Body>
//                   <h1>Persyaratan Administrasi</h1>
//                   {data.persyaratan ? (
//                     <>
//                       <Form.Row>
//                         <Form.Column>
//                           {data.persyaratan.map((syarat, i) => {
//                             return (
//                               <>
//                                 <Form.FileBrowser
//                                   label={
//                                     <>
//                                       {syarat.name}{' '}
//                                       <span className='text-red small'>
//                                         {' '}
//                                         *{syarat.extension}
//                                         <br /> (Max : {syarat.max_size /
//                                           1024}{' '}
//                                         KB)
//                                       </span>
//                                     </>
//                                   }
//                                   onChange={(e) => {
//                                     setFieldValue(`file_${syarat.id}`, {
//                                       file: e.target.files[0],
//                                       validation: {
//                                         extension: syarat.extension,
//                                         maxSize: syarat.max_size,
//                                       },
//                                       id: syarat.id,
//                                       keterangan: syarat.name,
//                                     });
//                                   }}
//                                   name={`file_${syarat.id}`}
//                                   downloadFile={
//                                     syarat.upload && (
//                                       <div className='col-lg'>
//                                         <span
//                                           // onClick={}
//                                           className='text-primary text-sm'
//                                           style={{ cursor: 'pointer' }}>
//                                           Lihat file terunggah
//                                         </span>
//                                       </div>
//                                     )
//                                   }
//                                   validationAlert={
//                                     errors[`file_${syarat.id}`] &&
//                                     touched[`file_${syarat.id}`] && (
//                                       <div id='feedback'>
//                                         {errors[`file_${syarat.id}`]}
//                                       </div>
//                                     )
//                                   }
//                                 />
//                               </>
//                             );
//                           })}
//                         </Form.Column>
//                       </Form.Row>
//                     </>
//                   ) : (
//                     ''
//                   )}
//                   <Form.Row>
//                     <Form.Column lg={12} md={12}>
//                       <button
//                         className='btn btn-primary float-right'
//                         onClick={handleSubmit}>
//                         Simpan
//                       </button>
//                     </Form.Column>
//                   </Form.Row>
//                 </Card.Body>
//               </Card>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// const mapValuesToPostParams = async (values) => {
//   const properties = [];
//   const newValues = Object.keys(values)
//     .filter((value) => value !== 'hotelId')
//     .map((key, i) => {
//       properties[i] = {
//         persyaratan_id: values[key].id,
//         hotel_registration_id: values.hotelId,
//         keterangan: values[key].keterangan,
//       };
//       return toBase64(values[key].file);
//     });

//   const postParams = await Promise.all(newValues).then((results) =>
//     results.map((result, i) => ({
//       persyaratan_id: properties[i].persyaratan_id,
//       hotel_registration_id: values.hotelId,
//       upload: result,
//       keterangan: properties[i].keterangan,
//     }))
//   );

//   return postParams;
// };

// const toBase64 = async (file) => {
//   if (await file) {
//     return new Promise((resolve, reject) => {
//       const reader = new FileReader();
//       reader.readAsDataURL(file);
//       reader.onload = () => resolve(reader.result);
//       reader.onerror = (error) => reject(error);
//     });
//   }
// };

// export default withFormik({
//   mapPropsToValues: (props) => ({ hotelId: 2 }),
//   validateOnBlur: false,
//   validate: (values) => {
//     const errors = {};
//     const keys = Object.keys(values).filter(
//       (key) => key.split('_')[0] === 'file'
//     );

//     keys.forEach((key) => {
//       if (!values[key].file) {
//         errors[key] = 'harus diisi';
//       } else {
//         const extensions = values[key].validation.extension
//           .split(',')
//           .map((validate) => validate);
//         const arrFileName = values[key].file.name.split('.');
//         const fileExtension = arrFileName[arrFileName.length - 1].toLowerCase();

//         if (!extensions.includes(fileExtension)) {
//           errors[
//             key
//           ] = `extensi file harus ${values[key].validation.extension}`;
//         }
//         if (values[key].file.size > values[key].validation.maxSize) {
//           errors[key] = `ukuran file melebihi ${
//             values[key].validation.maxSize / 1024
//           } KB`;
//         }
//       }
//     });

//     return errors;
//   },

//   handleSubmit: async (values, { setStatus }) => {
//     const params = await mapValuesToPostParams(values);
//     try {
//       const response = await Service.post('/hotel/registration/upload', params);
//       setStatus(response);
//     } catch (error) {
//       console.log(error);
//     }
//   },
// })(withReference([getPersyaratan(4)], ['persyaratan'])(Form2));
export default JasaBogaPersyaratan;
